module.exports = __webpack_public_path__ + "img/yalda_nemala_yes.894c2ce9.png";